import { EVENTS_PREFIX } from "core/config";
import { TCFEventStatus } from "../TCFConsentProvider/types";
import { _WINDOW_ } from "constants/dom";

export const EVENT_NAME = `${EVENTS_PREFIX}_tcf_consent_updated`;

/**
 * Get proper event status based on banner and consenst state.
 * 
 */
const getTCFEventStatus = (eventStatus: TCFEventStatus): TCFEventStatus => {
    switch (eventStatus) {
        case TCFEventStatus.TCLOADED:
            if (_WINDOW_.CF_visiblity) {
                return TCFEventStatus.IS_SHOWN
            }

            return eventStatus;

        case TCFEventStatus.INTERACTION_COMPLETE:
            return eventStatus
    }

    return TCFEventStatus.IS_SHOWN;
};

export default getTCFEventStatus;
